module.exports = __webpack_public_path__ + "img/close.a7a71342.svg";